// pages/Workshops.js
import React, { useState } from 'react';
// import '../styles/Workshops.css';

const workshops = [
  {
    id: 1,
    title: "Block Coding Fundamentals",
    duration: "2 weeks",
    level: "Beginner",
    description: "Learn the basics of programming through visual blocks",
    schedule: ["Mon & Wed", "4:00 PM - 5:30 PM"],
    upcoming: "2024-01-15"
  },
  // Add more workshops
];

export default function Workshops() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  return (
    <div className="workshops">
      <section className="workshops-hero">
        <h1>Digital Technology Workshops</h1>
        <p>Hands-on learning experiences in coding, robotics, and electronics</p>
      </section>

      <div className="workshop-filters">
        <button 
          className={selectedCategory === 'all' ? 'active' : ''}
          onClick={() => setSelectedCategory('all')}
        >
          All Workshops
        </button>
        <button 
          className={selectedCategory === 'coding' ? 'active' : ''}
          onClick={() => setSelectedCategory('coding')}
        >
          Coding
        </button>
        <button 
          className={selectedCategory === 'robotics' ? 'active' : ''}
          onClick={() => setSelectedCategory('robotics')}
        >
          Robotics
        </button>
        <button 
          className={selectedCategory === 'electronics' ? 'active' : ''}
          onClick={() => setSelectedCategory('electronics')}
        >
          Electronics
        </button>
      </div>

      <div className="workshops-grid">
        {workshops.map(workshop => (
          <div key={workshop.id} className="workshop-card">
            <div className="workshop-header">
              <h3>{workshop.title}</h3>
              <span className="duration">{workshop.duration}</span>
            </div>
            <div className="workshop-content">
              <p>{workshop.description}</p>
              <div className="workshop-details">
                <span>Level: {workshop.level}</span>
                <span>Schedule: {workshop.schedule.join(', ')}</span>
              </div>
              <button className="enroll-btn">Enroll Now</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}